import { RawHeaderNavigationEntry } from "@/components/layout/header";
import { createContext, useContext } from "react";

export interface NavbarEntry {
  label: string;
  url: string;
  image?: string;

  description?: string;

  parent?: NavbarEntry;
  subElements?: Map<string, NavbarEntry>;
}

export const rootNavbarEntry: NavbarEntry = {
  label: "Root",
  url: "/",
  subElements: new Map(),
};

export function toNavbarEntries(entries: RawHeaderNavigationEntry[], parent = rootNavbarEntry) {
  const converted = new Map<string, NavbarEntry>();
  let hadToCreateParent = parent === rootNavbarEntry;

  for (const e of entries) {
    const entry = {
      label: e.label,
      url: e.url,
      description: e.description,

      parent,
    } as NavbarEntry;

    if (e.subElements) {
      entry.subElements = toNavbarEntries(e.subElements, entry);
    }

    converted.set(e.label, entry);

    if (hadToCreateParent) {
      parent?.subElements?.set(e.label, entry);
    }
  }

  return converted;
}

export interface MobileMenuContextType {
  close(): void;

  allPages: Map<string, NavbarEntry>;
  currentPage: NavbarEntry;

  setAllPages(pages: Map<string, NavbarEntry>): void;
  setCurrentPage(page: NavbarEntry): void;
  up(): void;
}

// This will throw below, if the usage isn't wrapped with a <MobileMenuContextProvider/>
export const MobileMenuContext = createContext<MobileMenuContextType | null>(null);

export const useMobileMenu = () => {
  const ctx = useContext(MobileMenuContext);
  if (!ctx) {
    throw new Error("useMobileMenu must be used within a MobileMenuProvider");
  }

  return ctx;
};
